
import { useResumeState } from "./resume/useResumeState";
import { useResumePreview } from "./resume/useResumePreview";
import { useResumePayment } from "./resume/useResumePayment";
import { useResumeDeletion } from "./resume/useResumeDeletion";
import { useTestResume } from "./resume/useTestResume";
import { useDuplicateCheck } from "./resume/useDuplicateCheck";
import { useResumeFormat } from "./resume/useResumeFormat";

/**
 * Main hook that composes all resume operations functionality
 */
export const useResumeOperations = () => {
  const resumeState = useResumeState();
  const { handlePreview } = useResumePreview();
  const { handleDownloadClick, handlePayment } = useResumePayment();
  const { handleDeleteResume } = useResumeDeletion();
  const { handleCreateTestResume } = useTestResume();
  const { checkDuplicateResume } = useDuplicateCheck();
  const { onFormatSelect } = useResumeFormat();

  return {
    ...resumeState,
    handleCreateTestResume,
    handlePreview,
    handleDownloadClick,
    handlePayment,
    handleDeleteResume,
    checkDuplicateResume,
    onFormatSelect
  };
};
